import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchGoodsReceipts } from './api';

/** Branch-scoped — received stock belongs to the branch that received it. */
export function useGoodsReceipts() {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.pharmacy.goodsReceipts(), branchVersion],
    queryFn: fetchGoodsReceipts,
  });
}
